import React from "react";
import "../styles/layout-component.css";

const LayoutComponent = ({
  layout,
  templateData,
  onButtonClick,
  secondaryImage,
}) => {
  const layoutId = Number(layout);
  const layoutClass =
    layoutId === 1 || layoutId === 3 ? `layout-${layoutId}` : "layout-2";
  const imageSrc = templateData?.secondaryImageUrl || secondaryImage;

  return (
    <div className={`landing-card ${layoutClass}`}>
      <div className="landing-card-cluster">
        <img className="landing-card-image" src={imageSrc} alt="" />
        <div className="landing-card-content">
          <h1
            className="landing-card-heading"
            style={{ color: templateData.textColor }}
          >
            {templateData.heading || "Welcome to Swageazy Gift Redemption!"}
          </h1>
          <p
            className="landing-card-body"
            style={{ color: templateData.textColor }}
          >
            {templateData.content || "Click below to redeem your gift :)"}
          </p>
          <button
            type="button"
            onClick={onButtonClick}
            className="landing-card-button"
            style={{ backgroundColor: templateData.buttonColor }}
          >
            <span style={{ color: templateData.ctaColor }}>
              {templateData.buttonText || "Claim Swag"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LayoutComponent;
